import { smFunc } from '@/core/thinkhuge';

export function addEvent(type, source, origin) {
  smFunc.getJson('/app/helpers/process/?do=addEvent', 'POST', {
    type,
    source,
    origin,
  });
}
